import { Link } from 'react-router-dom';
import { featuredSpecials } from '@/mocks/anime';
import { articles } from '@/mocks/articles';

export default function FeatureSection() {
  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-8">
          <h2 className="text-xl md:text-2xl font-heading text-foreground-950 mb-1" style={{ fontFamily: 'var(--font-heading)' }}>
            特色专题
          </h2>
          <p className="text-sm text-foreground-600">不容错过的经典动漫与深度内容</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-10">
          {featuredSpecials.map((item) => (
            <Link
              key={item.id}
              to={`/article/${item.id}`}
              className="group relative h-48 rounded-lg overflow-hidden cursor-pointer"
            >
              <img
                src={item.coverUrl}
                alt={item.title}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                title={`${item.title} - 樱花动漫之家`}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-4">
                <h3 className="text-sm font-medium text-background-50 mb-1">{item.title}</h3>
                <p className="text-xs text-background-50/70 line-clamp-2">{item.description}</p>
              </div>
            </Link>
          ))}
        </div>

        <div className="mb-8">
          <div className="flex items-center justify-between mb-5">
            <h3 className="text-lg font-heading text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
              深度文章
            </h3>
            <Link
              to="/category/zixun"
              className="text-sm text-primary-500 hover:text-primary-600 flex items-center gap-1 cursor-pointer whitespace-nowrap"
            >
              更多文章 <i className="ri-arrow-right-line text-xs"></i>
            </Link>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {articles.slice(0, 3).map((article) => (
              <Link
                key={article.id}
                to={`/article/${article.id}`}
                className="group bg-background-50 rounded-lg overflow-hidden border border-secondary-200 hover:border-primary-200 transition-all cursor-pointer"
              >
                <div className="aspect-[16/9] overflow-hidden bg-background-200">
                  <img
                    src={article.coverUrl}
                    alt={article.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                    title={`${article.title} - 樱花动漫之家`}
                  />
                </div>
                <div className="p-4">
                  <div className="flex items-center gap-2 mb-2">
                    <span className="text-xs text-foreground-500">{article.date}</span>
                    <span className="text-xs text-foreground-400">·</span>
                    <span className="text-xs text-foreground-500">{article.readTime}</span>
                  </div>
                  <h4 className="text-sm font-medium text-foreground-950 group-hover:text-primary-500 transition-colors line-clamp-2 mb-2">
                    {article.title}
                  </h4>
                  <p className="text-xs text-foreground-600 line-clamp-2">{article.excerpt}</p>
                  <div className="flex items-center gap-2 mt-3 flex-wrap">
                    {article.tags.map((tag) => (
                      <span key={tag} className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 text-xs">
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}